import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  USER_TRANSFER,
  USER_TRANSFER_RECORD,
  USER_TRANSFER_RECORD_LIST,
} from "@/config";
import PostRequest from "@/components/PostRequest";
import { useAuthContext } from "@/auth/useAuthContext";
export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  const user_transfer = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "recordId": "202403220335xxxxxxxxx837507252224"
  }
  }
    `,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_TRANSFER : "***"}"
    args := []byte(${`{
      "coinId": 1280,
      "fromUserId": "1709021102608",
      "toUserId": "1709021101247",
      "orderId": "usertransfer0001",
      "amount": "0.005"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
      signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }`,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? USER_TRANSFER : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("coinId", 1280);
    map.put("fromUserId", "1709021102608");
    map.put("toUserId", "1709021101247");
    map.put("orderId", "usertransfer0001");
    map.put("amount", "0.005");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: ` # Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_TRANSFER : "***"}"
  content = {
    "coinId": 1280,
    "fromUserId": "1709021102608",
    "toUserId": "1709021101247",
    "orderId": str(int(time.time() * 1000)),
    "amount": "0.005",
    # "remark": "test1"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? USER_TRANSFER : "***"}';
  const args = JSON.stringify({
    'coinId': 1280,
    'fromUserId': '1709021102608',
    'toUserId': '1709021101247',
    'orderId': '12121212',
    'amount': '0.005',
    # 'remark': 'test1'
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
    respData += chunk;
  });
  
  res.on('end', () => {
    console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_TRANSFER : "***"}";
  $content   = [
    "coinId"=>1329,
    "fromUserId"=>"",
    "toUserId"=>"",
    "orderId" => "",
    "amount"=>"1",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const user_transfer_record = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
  "record": {
    "recordId": "202403220337521771018432423137280",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "orderId": "6322718677975328",
    "fromUserId": "6322718677975328",
    "toUserId": "6322821127078176",
    "amount": "0.002",
    "status": "Success"
  }
  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_TRANSFER_RECORD : "***"}"
    args := []byte(${`{
        "recordId": "202403010610541763446796748591104"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
      signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
  String appId = "*** your appId ***";
  String appSecret = "*** your appSecret ***";
  // With request params
  String path = "${check ? USER_TRANSFER_RECORD : "***"}";
  
  // params
  Map<String, Object> map = new HashMap<>();
  map.put("recordId", "202403010610541763446796748591104");
  
  ObjectMapper mapper = new ObjectMapper();
  mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
  String inputString = mapper.writeValueAsString(map);
  
  byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
  // Sign
  long timestamp = new Date().getTime() / 1000L;
  String signText = appId + timestamp;
  if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
  }
  Mac sha256Hmac = Mac.getInstance("HmacSHA256");
  SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
  sha256Hmac.init(secretKey);
  byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
  String sign = byteArrayToHexString(signBytes);
  
  // Making API call
  HttpClient client = HttpClientBuilder.create().build();
  HttpPost request = new HttpPost(path);
  request.setHeader("Appid", appId);
  request.setHeader("Sign", sign);
  request.setHeader("Timestamp", String.valueOf(timestamp));
  request.setEntity(new ByteArrayEntity(requestBody));
  HttpResponse response = client.execute(request);
  BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
  StringBuilder responseText = new StringBuilder();
  String line;
  while ((line = reader.readLine()) != null) {
      responseText.append(line);
  }
  reader.close();
  
  // result
  System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
  StringBuilder hs = new StringBuilder();
  String tempStr;
  for (int index = 0; bytes != null && index < bytes.length; index++) {
    tempStr = Integer.toHexString(bytes[index] & 0XFF);
    if (tempStr.length() == 1) {
       hs.append('0');
    }
    hs.append(tempStr);
  }
  return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: ` # Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_TRANSFER_RECORD : "***"}"
  content = {
    "recordId": "202403010610541763446796748591104",
    # "orderId": "1708507495559"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
  "Content-Type": "application/json;charset=uf8",
  "Appid": app_id,
  "Sign": server_sign,
  "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? USER_TRANSFER_RECORD : "***"}';
  const args = JSON.stringify({
    'recordId': '202403010610541763446796748591104',
    # 'orderId': '1708507495559'
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
    respData += chunk;
  });
  
  res.on('end', () => {
    console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_TRANSFER_RECORD : "***"}";
  $content   = [
  "recordId"=>"202403220xxxxxx8432423137280",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
  $sign_text = $sign_text . $body;
  } else {
  $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
  "headers" => array(
    "Content-Type: application/json;charset=utf-8",
    "Appid: " . $app_id,
    "Sign: " . $server_sign,
    "Timestamp: " . $timestamp
  ),
  "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const user_transfer_record_list = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "records": [
      {
        "recordId": "202403130959411767853027680587776",
        "coinId": 1891,
        "coinSymbol": "TETH",
        "orderId": "6322820357488929",
        "fromUserId": "6322718677975328",
        "toUserId": "6322820357488928",
        "amount": "0.001",
        "status": "Success"
      },
      ...
    ],
    "nextId": ""
  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_TRANSFER_RECORD_LIST : "***"}"
    args := []byte(${`{
        "fromUserId": "1709021102608"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }
      `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
  String appId := "*** your appId ***";
  String appSecret = "*** your appSecret ***";
  // With request params
  String path = "${check ? USER_TRANSFER_RECORD_LIST : "***"}";
  
  // params
  Map<String, Object> map = new HashMap<>();
  map.put("fromUserId", "1709021102608");
  
  ObjectMapper mapper = new ObjectMapper();
  mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
  String inputString = mapper.writeValueAsString(map);
  
  byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
  // Sign
  long timestamp = new Date().getTime() / 1000L;
  String signText = appId + timestamp;
  if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
  }
  Mac sha256Hmac = Mac.getInstance("HmacSHA256");
  SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
  sha256Hmac.init(secretKey);
  byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
  String sign = byteArrayToHexString(signBytes);
  
  // Making API call
  HttpClient client = HttpClientBuilder.create().build();
  HttpPost request = new HttpPost(path);
  request.setHeader("Appid", appId);
  request.setHeader("Sign", sign);
  request.setHeader("Timestamp", String.valueOf(timestamp));
  request.setEntity(new ByteArrayEntity(requestBody));
  HttpResponse response = client.execute(request);
  BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
  StringBuilder responseText = new StringBuilder();
  String line;
  while ((line = reader.readLine()) != null) {
    responseText.append(line);
  }
  reader.close();
  
  // result
  System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
  StringBuilder hs = new StringBuilder();
  String tempStr;
  for (int index = 0; bytes != null && index < bytes.length; index++) {
    tempStr = Integer.toHexString(bytes[index] & 0XFF);
    if (tempStr.length() == 1) {
        hs.append('0');
    }
    hs.append(tempStr);
  }
  return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: ` # Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_TRANSFER_RECORD_LIST : "***"}"
  content = {
      "fromUserId": "1709021102608",
      # "toUserId": "1709021101247",
      # "coinId": 2523,
      # "startAt": 1704042061,
      # "endAt": 1708581993,
      # "nextId": ""
  }
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId := '*** your appId ***';
  const appSecret = '*** your appSecret ***';
  
  const path = '${check ? USER_TRANSFER_RECORD_LIST : "***"}';
  const args = JSON.stringify({
      'fromUserId': '1709021102608',
    # 'toUserId': '1709021101247',
    # 'coinId': 2523,
    # 'startAt': 1704042061,
    # 'endAt': 1708581993,
    # 'nextId': ''
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
    respData += chunk;
  });
  
  res.on('end', () => {
    console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_TRANSFER_RECORD_LIST : "***"}";
  $content   = [
      "fromUserId"=>"6322718677975328",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 发起用户转账 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="apis-related-to-user-transfers" className="title">
              {translate("merchant_user_wallet_mode_API.text_77")}
            </Box>
            <Box id="initiate-user-transfers" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_78")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_79")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "fromUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_80")}`,
                },
                {
                  name: "toUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_81")}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_55")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
                {
                  name: "remark",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_82")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_transfer[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 发起用户转账 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_44_2"
                  )}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              {translate("merchant_user_wallet_mode_API.text_83")}
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-transfer-records" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_84")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_85")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER_RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_59_"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_transfer_record[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账记录 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },

                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_86")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_87")}`,
                },

                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_88")}`,
                },
                {
                  name: "data.record.fromUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_89")}`,
                },
                {
                  name: "data.record.toUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_90")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_91")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.remark",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_92")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-transfer-history" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_93")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_94")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER_RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "fromUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_80")}`,
                },
                {
                  name: "toUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_81")}`,
                },

                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_transfer_record_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账历史记录 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].fromUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_89")}`,
                },
                {
                  name: "data.records[index].toUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_81")}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_86")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_87")}`,
                },

                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_88")}`,
                },

                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_91")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23_1"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
